module.exports = __webpack_public_path__ + "static/media/down.2ab7a44a.png";